<template>
    <chart id="opt" :options="opt" />
</template>

<script>

  import ECharts from 'vue-echarts';
  import 'echarts/lib/component/graphic';

  export default {
    name: 'a5',
    props: {},
    components: { chart: ECharts },
    data() {
      return {
        opt: {}
      };
    },
    created() {
      this.opt = {
        title: {
          show: false
        },
        backgroundColor: '#fff',
        graphic: [{
          type: 'group',
          left: 'center',
          bottom: 10,
          children: [{
            type: 'text',
            z: 100,
            left: '10',
            top: 'middle',
            style: {
              fill: '#000',
              text: '磁盘剩余空间：',
              font: '16px Microsoft YaHei'
            }
          }, {
            type: 'text',
            z: 100,
            left: '120',
            top: 'middle',
            style: {
              fill: '#000',
              text: '128G',
              font: '24px Microsoft YaHei'
            }
          }]
        }],
        series: [{
          type: 'liquidFill',
          waveAnimation: true,
          radius: '70%',
          center: ['50%', '40%'],
          data: [0.5],
          backgroundStyle: {
            borderWidth: 5,
            borderColor: '#1daaeb',
            color: '#fff'
          },
          label: {
            normal: {
              formatter: (0.5 * 100).toFixed(2) + '%',
              textStyle: {
                fontSize: 20
              }
            }
          }
        }]
      };
    }
  };
</script>
<style scoped>

</style>
